
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#74C7AD',
    lighten1: 'E5F5F0',
    darken1: colors.purple.darken2,
    accent1: '#ff12ff'
  },
  secondary: {
    base: '#F0645A'
    // colors.indigo,
  },
  error: {
    base: colors.red.accent1
  },
  accent: {
    base: colors.teal.accent1,
    lighten1: colors.orange.lighten1
  }

}
